import { z } from "zod";
import { DbCreateInputOmit } from "../helpers";
import { ForgeProjectRole } from "./project-membership";

export const ForgeProjectInvitation = z.object({
  email: z.string().email(),
  forgeProjectId: z.string(),
  workspaceInvitationId: z.string(),
  role: ForgeProjectRole,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  createdById: z.string(),
});

export type ForgeProjectInvitation = z.infer<typeof ForgeProjectInvitation>;
export type CreateForgeProjectInvitation = DbCreateInputOmit<ForgeProjectInvitation>;
